import TextField from '@mui/material/TextField'

type PlainTextFieldProps = {
    value: string,
    setValue: (value: string) => void
    label: string,
    id: string,
    hasError: boolean,
    disabled: boolean
}


const PlainTextField = (props: PlainTextFieldProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.setValue(event.target.value)
    }

    return <TextField
        disabled={props.disabled}
        error={props.hasError}
        label={props.label}
        id={props.id}
        size="small"
        value={props.value}
        onChange={handleChange}
    />
}

export default PlainTextField